import {RandomUtils} from '@colonist/utils'
import {ClientUserSessionState} from '../../../../shared/ClientUserSessionState'
import {LobbyImage} from '@colonist/types'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {StorageWrapper} from '../StorageWrapper'
import {clientI18n} from '../ClientI18n'
import {ClientUserState} from '../ClientUserState'

export class LogRocketController {
    private readonly active: boolean = false
    private readonly USER_SELECTION_DENOMINATOR = 10000

    private logRocket: any | undefined

    constructor() {
        if(UIUtilsEjsVariables.logRocketId == '') return
        const logRocketStorageActive = StorageWrapper.getLogRocket()
        if(logRocketStorageActive == false) return

        const random = RandomUtils.randomIntBetween(0, this.USER_SELECTION_DENOMINATOR)
        this.active = logRocketStorageActive || random == 1

        if(!logRocketStorageActive) StorageWrapper.setLogRocket(this.active)
    }

    async init() {
        if(!this.active) return
        if(this.logRocket != undefined) return

        const {default: logRocket} = await import('logrocket')
        this.logRocket = logRocket

        await this.logRocket.init(UIUtilsEjsVariables.logRocketId)
    }

    set(session: ClientUserSessionState) {
        if(this.logRocket == undefined) return
        if(ClientUserState.userState == undefined) return

        const karmaText = ClientUserState.userState.getPlayerKarmaStatusText()
        karmaText.options = {
            ...karmaText.options,
            lng: 'en',
        }
        const languageAgnosticKarmaTextStatus = clientI18n.t(karmaText.key, karmaText.options)

        this.logRocket.identify(session.id, {
            name: ClientUserState.userState.username,

            // Add your own custom user variables here, ie:
            loggedIn: String(ClientUserState.userState?.isLoggedIn),
            karmaTextStatus: languageAgnosticKarmaTextStatus,
            icon: String(LobbyImage[ClientUserState.userState.icon]),
        })
    }
}
